export class GetConfigurationTypes{
  static readonly type = '[Insight-Configuration] Get types'
}

export class SetSelectedConfigType {
  static readonly type = '[Insight-Configuration] Set Selected Type data'
  constructor(public selectedType: any){}
}

export class GetConfigurationList{
  static readonly type = '[Configuration] Get List'
  constructor(public plantId?: string){}
}

export class DeleteConfiguration{
  static readonly type = '[Configuration] Delete Configuration'
  constructor(public id: string){}
}

export class GetUserAccess {
  static readonly type = '[Congiguration] GetUserAccess'
}

export class GetPlantList {
  static readonly type = '[Configuration] Get Plant List'
}

export class SetSelectedPlant {
  static readonly type = '[Configuration] Set selected Plant'
  constructor(public plant: any){}
}

export class GetRolesAndDepartmentByAsset {
  static readonly type = '[Configuration] Get Roles and Department By Asset'
  constructor(public assetId: string) {}
}